import React from 'react';
import { getResolutionReasonLabel, getWeekdayLabel } from '../../../constants/violationConstants';
import { formatInTimezone } from '../../../utils/formatInTimezone';
import { ACTIVATION_SCHEDULED } from '../../../utils/violationSchedule';

/**
 * P2-03 / Resolution reason и schedule context.
 *
 * Presence-driven: пока backend не отдаёт resolution/activation_context,
 * панель возвращает null. Для активного нарушения resolution всегда null
 * (ТЗ 5.2), поэтому причина завершения не рисуется.
 */
const ResolutionContextPanel = ({ event, timezone }) => {
  const resolution = event?.resolution;
  const context = event?.activation_context;
  if (!resolution && !context) return null;

  return (
    <div className="vio-card">
      <p className="vio-drawer-section-title">Контекст завершения</p>

      <div className="vio-readonly-grid">
        {resolution && (
          <>
            <div>
              <div className="vio-readonly-label">Причина завершения</div>
              <div className="vio-readonly-value">
                {getResolutionReasonLabel(resolution.reason_code)}
              </div>
            </div>
            <div>
              <div className="vio-readonly-label">Время завершения</div>
              <div className="vio-readonly-value">
                {resolution.resolved_at ? formatInTimezone(resolution.resolved_at, timezone) : '—'}
              </div>
            </div>
          </>
        )}

        {context && (
          <>
            <div>
              <div className="vio-readonly-label">Режим активации</div>
              <div className="vio-readonly-value">
                {context.mode === ACTIVATION_SCHEDULED ? 'По расписанию' : 'Всегда активно'}
              </div>
            </div>
            {context.window && (
              <div>
                <div className="vio-readonly-label">Окно расписания</div>
                <div className="vio-readonly-value">
                  {getWeekdayLabel(context.window.weekday)}{' '}
                  {context.window.start_time} — {context.window.end_time}
                  {context.timezone ? ` (${context.timezone})` : ''}
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {context?.schedule_version != null && (
        <p className="vio-field-hint">{`Версия расписания ${context.schedule_version}`}</p>
      )}
    </div>
  );
};

export default ResolutionContextPanel;
